import React, { useState, useRef, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import OpportunityImpactGraph from '../../../opportunities/OpportunityImpactGraph';
import OverviewTable from './OverviewTable';
import OverviewTableMobile from './../../../../mobile/OverviewTableMobile';
import useAxiosProtect from '../../../../hooks/useAxiosProtect';
import { isMobile } from 'react-device-detect';

const Overview = props => {
    const [timeRef, setTimeRef] = useState('month');
    const [siteLookup, setSiteLookup] = useState({});

    const [isLoading, setIsLoading] = useState(true);

    const [tableData, setTableData] = useState([]);
    const [totals, setTotals] = useState(null);

    const axiosProtect = useAxiosProtect();

    var init = useRef(true);

    useEffect(() => {
        if(!init.current) return;
        console.log(props.userData.id)
        axiosProtect.get(`/auth/query/list-client-site-access?uid=${props.userData.id}`).then(response => {
            let sites = [...response.data.sites];
            let lookupTemp = {};

            for(let i = 0;i<sites.length;++i){
                lookupTemp[`${sites[i].id}`] = sites[i].name;
            }

            setSiteLookup({...lookupTemp});

        }).catch(err => {});
    }, []);

    useEffect(() => {
        if(!init.current || Object.keys(siteLookup).length === 0) return;

        init.current = false;

        let idArray = Object.keys(siteLookup).map(siteID => `ids=${siteID}`).join('&');

        axiosProtect.get(`/org/org-level?timeRef=${timeRef}&${idArray}`).then(response => {
            let payload = {...response.data.siteTotals};

            let tableDataTemp = [];

            for(let key in payload){
                let siteTableObject = {...payload[key]};
                siteTableObject.active = true;
                siteTableObject.siteName = siteLookup[key];
                siteTableObject.siteID = key;

                tableDataTemp.push(siteTableObject);
            }

            setTableData([...tableDataTemp]);

            let tempTotals = {
                water: {prev: 0, curr: 0, pctChange: 0},
                electricity: {prev: 0, curr: 0, pctChange: 0},
                gas: {prev: 0, curr: 0, pctChange: 0},
                ghg: {prev: 0, curr: 0, pctChange: 0},
                cost: {prev: 0, curr: 0, pctChange: 0}
            };

            for(let i = 0; i<tableDataTemp.length;++i){
                tempTotals.water.prev += tableDataTemp[i].water.prev;
                tempTotals.water.curr += tableDataTemp[i].water.curr;

                tempTotals.electricity.prev += tableDataTemp[i].electricity.prev;
                tempTotals.electricity.curr += tableDataTemp[i].electricity.curr;

                tempTotals.gas.prev += tableDataTemp[i].gas.prev;
                tempTotals.gas.curr += tableDataTemp[i].gas.curr;

                tempTotals.ghg.prev += tableDataTemp[i].ghg.prev;
                tempTotals.ghg.curr += tableDataTemp[i].ghg.curr;

                tempTotals.cost.prev += tableDataTemp[i].cost.prev;
                tempTotals.cost.curr += tableDataTemp[i].cost.curr;
            }

            tempTotals.water.pctChange = tempTotals.water.prev === 0 ? null : (tempTotals.water.curr - tempTotals.water.prev) / tempTotals.water.prev;
            tempTotals.electricity.pctChange = tempTotals.electricity.prev === 0 ? null : (tempTotals.electricity.curr - tempTotals.electricity.prev) / tempTotals.electricity.prev;
            tempTotals.gas.pctChange = tempTotals.gas.prev === 0 ? null : (tempTotals.gas.curr - tempTotals.gas.prev) / tempTotals.gas.prev;
            tempTotals.ghg.pctChange = tempTotals.ghg.prev === 0 ? null : (tempTotals.ghg.curr - tempTotals.ghg.prev) / tempTotals.ghg.prev;
            tempTotals.cost.pctChange = tempTotals.cost.prev === 0 ? null : (tempTotals.cost.curr - tempTotals.cost.prev) / tempTotals.cost.prev;

            setTotals({...tempTotals});
            setIsLoading(false);
        }).catch(err => {});
    }, [siteLookup]);

    return(
        <>
            <br/>
            {isMobile ? (
                <OverviewTableMobile tableData={tableData} totals={totals} isLoading={isLoading}/>
            ): (
                <OverviewTable tableData={tableData} totals={totals} isLoading={isLoading}/>
            )}
            
        </>
    );
}

export default Overview;